import React, { memo } from "react";
import { BiTimer } from "react-icons/bi";
import anim from "../../utils/anim";
import { Card, Loader } from "../CoreUI";
import { PerformanceModuleRedirectButton } from "./PerformanceModule";

const LookerDashPerformance = memo(
	({
		redirectButtonTo = "",
		redirectButtonText = "",
		iframeSrc,
		isPending,
	}) => {
		return (
			<Card
				className="performance-analysis-module"
				variants={anim.preview}
				initial="initial"
				animate="animate"
			>
				{isPending ? (
					<Loader center />
				) : !iframeSrc ? (
					<Card className="performance-analysis-module-empty">
						<span
							className="performance-analysis-module-empty-icon"
							role="img"
							aria-label="Soon icon"
						>
							<BiTimer />
						</span>
						<h2>Coming soon!</h2>
						<h4>We are working on your dashboard</h4>
					</Card>
				) : (
					<>
						<iframe title="Looker Dashboard" src={iframeSrc} />
						{redirectButtonText && (
							<PerformanceModuleRedirectButton
								to={redirectButtonTo}
							>
								{redirectButtonText}
							</PerformanceModuleRedirectButton>
						)}
					</>
				)}
			</Card>
		);
	}
);

export default LookerDashPerformance;
